export default __webpack_public_path__ + "static/media/weish.6eb3370d.jpg";